import styled from "styled-components";

interface props {
  $bgColor?: string;
}

export const PageContainer = styled.div<props>`
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  max-width: 45rem;
  margin: 0 auto;
  position: relative;
  background: ${(props) => (props.$bgColor ? props.$bgColor : "#f7f7f7")};
  overflow-y: auto;
  padding: 0 16px;
  box-sizing: border-box;
`;
